export const SNAP_SHEET_TRANSITION_DURATION = 300;
